import { getCustomisationFieldData, getGroupData } from "../../EditablePreview/EditablePreview";
import AudioField from "./audio/AudioField";
import DropdownField from "./dropdown/DropdownField";
import ImageField from "./image/ImageField";
import NumberField from "./numberField/NumberField";
import RangeSliderField from "./rangeSlider/RangeSliderField";
import StringField from "./stringField/StringField";
import ToggleField from "./toggle/ToggleField";

const findVal = (valsObject, varName, tabKey = null, altValsObject = null) => {
    // console.log('--- Finding val: ', valsObject, varName);
    const varNameParts = varName.split('.');
    let ousideTabVal = null;
    for (let tab in valsObject) {
        for (let group in valsObject[tab]) {
            for (let subGroup in valsObject[tab][group]) {
                for (let i = 0; i < valsObject[tab][group][subGroup].length; i++) {
                    for (let valName in valsObject[tab][group][subGroup][i]) {
                        if (valName === varNameParts[varNameParts.length - 1]) {
                            // console.log('Found match!');
                            // The names match!
                            if (varNameParts.length === 1) {
                                // We only supplied the val name, so let's assume it is unique
                                return valsObject[tab][group][subGroup][i][valName];
                            }
                            // check if the path to the value (or part path) matches what was supplied
                            let pathMatchCheck = "";
                            if (varNameParts.length === 4) {
                                pathMatchCheck += tab + '.';
                            }
                            if (varNameParts.length >= 3) {
                                pathMatchCheck += group + '.';
                            }
                            if (varNameParts.length >= 2) {
                                pathMatchCheck += subGroup + '.';
                            }
                            pathMatchCheck += valName;
                            // console.log('Path to match: ', pathMatchCheck);
                            if (pathMatchCheck === varName) {
                                if (tab === tabKey) {
                                    // console.log('Val in same tab!');
                                    return valsObject[tab][group][subGroup][i][valName];
                                } else {
                                    // Remember as a first possible match, but keep looking for a match in the same tab
                                    if (ousideTabVal === null) {
                                        ousideTabVal = valsObject[tab][group][subGroup][i][valName];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    if (ousideTabVal !== null) {
        // console.log('Val outside tab: ', ousideTabVal);
        return ousideTabVal;
    }

    if (altValsObject) {
        return findVal(altValsObject, varName, tabKey);
    }

    return undefined;
};

const evaluateDisplayConditions = (displayConditions, getValFunc) => {
    let displayControl = true;
    if (displayConditions && displayConditions.length > 0) {
        // console.log('>>>> EVALING CONDITIONS: ', displayConditions);
        const condArr = displayConditions;
        for (let condI = 0; condI < displayConditions.length; condI++) {
            const condVal = displayConditions[condI];
            // console.log('--->>>> EVALIING CONDITION: ', condVal);
        // displayConditions.forEach(
            // (condVal, condI, condArr) => {
                if (displayControl) {
                    // We hit an OR, so we can skip the rest of the conditions if we already evaluated to true
                    if (condVal.evalCondition === 'OR' && displayConditions.length > condI + 1) {
                        // console.log('HIT OR! Return ', displayControl);
                        return displayControl;
                    }
                    const displayConditionVal = getValFunc(condVal);
                    if (typeof displayConditionVal !== 'undefined') {
                        // Anything that is not a number needs to be enclosed in quotes in our eval string (so we can make > and < work and also arbitrary strings like "none")
                        const evalStr = typeof condVal.val === 'number' && typeof displayConditionVal === 'number' ?
                            String(displayConditionVal) + condVal.evalCondition + String(condVal.val) :
                            "'" + String(displayConditionVal) + "'" + condVal.evalCondition + "'" + String(condVal.val) + "'";
                        // console.log('Eval string: ', evalStr, eval(evalStr));
                        displayControl = eval?.(evalStr);
                    }
                } else {
                    // We have evaluated to false, but we hit an OR, so we need to reset the display control to true if there are more conditions to evaluate
                    if (condVal.evalCondition === 'OR' && displayConditions.length > condI + 1) {
                        // console.log('HIT OR! Reset displayControl to true and evaluate next block...')
                        displayControl = true;
                    }
                }
            //}
        // );
        }
    }
    return displayControl;
};

const evaluateDisplayConditionsForField = (props, fieldDataIn) => {
    let shouldDisplay = true;
    // Split the dataLink and extract the customisation schema data for each step and log it out
    if (fieldDataIn?.customFieldConfig?.dataLink) {
        const familyData = getGroupData(props.customisationVars, fieldDataIn.customFieldConfig.dataLink, props.index ?? 0);
        const dataLinkParts = fieldDataIn.customFieldConfig.dataLink.split('.');
        for (let i = 0; i < dataLinkParts.length; i++) {
            let path = '';
            for (let j = 0; j <= i; j++) {
                path += (j > 0 ? '.' : '') + dataLinkParts[j];
            }
            // console.log('CustomFieldRenderer DataLink Part:', path, getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, path, props.index ?? 0, props.visualisationComponentKey ?? null));
            const fieldDataSchema = getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, path, props.index ?? 0, props.visualisationComponentKey ?? null);
            // Check for any display conditions on this field
            if (fieldDataSchema?.displayCondition && Array.isArray(fieldDataSchema.displayCondition)) {
                shouldDisplay = evaluateDisplayConditions(fieldDataSchema.displayCondition, 
                    (condVal) => {
                        if (typeof (familyData[condVal.var]) !== 'undefined') {
                            return familyData[condVal.var]
                        } else {
                            const rootVals = props.customisationVars;
                            // Otherwise search for the val elsewhere
                            return findVal(rootVals, condVal.var);
                        }
                    }
                );
                if (!shouldDisplay) {
                    // No need to check further, one failed condition is enough to hide the field
                    return false;
                }
            }
        }
    }
    return true;
}

export const customFieldRenderer = (props) => {
    const { fieldData, moduleConfig, groupConfig, customisationVars } = props;
    console.log('CustomFieldRenderer:', props, fieldData?.customFieldConfig?.customFieldType);
    
    // Split the dataLink and extract the customisation schema data for each step and log it out
    /* console.log('CustomFieldRenderer DataLink Part:', '-- Top --', getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, '', props.index ?? 0, props.visualisationComponentKey ?? null));
    if (fieldData?.customFieldConfig?.dataLink) {
        const dataLinkParts = fieldData.customFieldConfig.dataLink.split('.');
        for (let i = 0; i < dataLinkParts.length; i++) {
            let path = '';
            for (let j = 0; j <= i; j++) {
                path += (j > 0 ? '.' : '') + dataLinkParts[j];
            }
            console.log('CustomFieldRenderer DataLink Part:', path, getCustomisationFieldData(props.campaignData, props.selectedFeatureNode.featureData._id, path, props.index ?? 0, props.visualisationComponentKey ?? null));
        }
    } */

    switch (fieldData?.customFieldConfig?.customFieldType.toLowerCase()) {
        case 'imageupload':
            return <ImageField {...props} />;
        case 'audioupload':
            return <AudioField {...props} />;
        case 'dropdown':
            return <DropdownField {...props} />;
        case 'toggle':
            return <ToggleField {...props} />;
        case 'range':
            return <RangeSliderField {...props} />;
        case 'string':
            return <StringField {...props} />;
        case 'number':
            return <NumberField {...props} />;
        // Add more cases for different field types as needed
        default:
            return null;
    }
}

export const CustomFieldBlock = (props) => {
    const { customFields } = props;
    console.log('CustomFieldBlock:', props);

    const isOddLengthArray = () => {
        let length = 0;
        for (let i = 0; i < customFields.length; i++) {
            length++;
            // Wide fields cause our length to become even
            if (length % 2 === 1 && customFields[i].customFieldConfig?.isWide) {
                length++;
            }
        }
        return length % 2 === 1;
    }

    return (
         <div className='v2-module-columns-holder wrap'>
            {customFields.map((fieldData, index) => {
                const oddLengthArray = isOddLengthArray();
                const shouldDisplay = evaluateDisplayConditionsForField(props, fieldData);
                const shouldDisplayStyle = {
                    // opacity: shouldDisplay ? 1 : 0.25,
                    // pointerEvents: shouldDisplay ? 'auto' : 'none',
                }
                return (
                    <div className={`v2-module-one-column${((oddLengthArray && index === customFields.length - 1) || fieldData.customFieldConfig?.isWide) ? ' v2-full-width' : ''}`} key={index} style={shouldDisplayStyle}>
                        {customFieldRenderer({ ...props, fieldData, isEnabled: shouldDisplay })}
                    </div>
                );
            })}
        </div>
    );
}

export const renderFirstCustomBlock = (props) => {
    const moduleConfig = props.moduleConfig;
    const customFields = [];
    
    // Pull out all the custom fields until we reach a non-custom field, these will be rendered about the normal fields in a module
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const fieldData = moduleConfig.fields[i];
        if (fieldData?.field === 'customCustomisationField' && fieldData?.customFieldConfig?.customFieldType) {
            customFields.push(fieldData);
        } else {
            break;
        }
    }

    if (customFields.length === 0) {
        return null;
    }

    return (
        <CustomFieldBlock customFields={customFields} {...props} />
    )
}

export const renderSecondCustomBlock = (props) => {
    const moduleConfig = props.moduleConfig;
    const customFields = [];

    // Ignore any custom fields until we hit a non-custom fields, collect all custom fields after that into our array
    let foundNonCustomField = false;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const fieldData = moduleConfig.fields[i];
        if (fieldData?.field === 'customCustomisationField' && fieldData?.customFieldConfig?.customFieldType) {
            if (foundNonCustomField) {
                customFields.push(fieldData);
            }
        } else {
            foundNonCustomField = true;
        }
    }

    if (customFields.length === 0) {
        return null;
    }

    return (
        <CustomFieldBlock customFields={customFields} {...props} />
    )
}
